// Data sources whose single-shift refresh (`POST /shifts/{id}/sync`) the
// backend serves. Mirrors `_SINGLE_SHIFT_SYNC_SUPPORTED_VENDORS` in
// services/api/routes/organizations/shifts.py; keep the two in step so the
// shift page's Sync control neither hides a working refresh nor offers one
// that 4xxs.
export const SHIFT_SYNC_CAPABLE_ACCOUNT_TYPES: ReadonlySet<string> = new Set([
    'alayacare',
    'axiscare',
    'hhaexchange',
    'wellsky',
]);

export type ShiftSyncAccount = {
    readonly sync_enabled: boolean;
    readonly type: string;
};

export function hasShiftSyncCapableAccount(
    accounts: ReadonlyArray<ShiftSyncAccount> | undefined,
): boolean {
    return (
        accounts?.some(
            (account) =>
                SHIFT_SYNC_CAPABLE_ACCOUNT_TYPES.has(account.type) &&
                account.sync_enabled,
        ) ?? false
    );
}
